/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { IInspectorControl_String, TInspectorControlProps } from "../InspectorControlTypes";
import { IFieldValidationError } from "../../../ui/components/Fields/FieldTypes";

export interface IInspectorControlStringProps extends TInspectorControlProps<IInspectorControl_String> {
	label?: string;
	onFocus?: React.FocusEventHandler<HTMLInputElement>;
	onBlur?: React.FocusEventHandler<HTMLInputElement>;
	readOnly?: boolean;
	validationErrors?: IFieldValidationError[];
}

export const schemaName = "constString";
